// extracted by mini-css-extract-plugin
export default {"container":"HistoryRow_container__uaaP1","date":"HistoryRow_date__CXXw2","time":"HistoryRow_time__ERpK1"};